/*
 * A stitch target (E1 `courses[].stitchTargets[]`, E5 `stitchTargets[]`) → a
 * picker option: the student's own live batch that "stitch into an existing
 * batch" may link (R-07-06).
 */

import { toDisplayDate } from "./timings";

/**
 * `startDate` and `timings` travel with the option: the list keeps only batches
 * that start after the one being stitched, and the target's own timings are what
 * the preview answers its earliest start for (E3 `successor.timings`).
 * @param {{batchId: string, name: string, mentorName?: string, startDate?: string,
 *          timings?: Object[]}} target
 * @returns {{value: string, label: string, startDate: string, timings: Object[]}}
 */
export const stitchTargetMapper = (target) => ({
  value: target?.batchId,
  startDate: target?.startDate ?? "",
  timings: target?.timings ?? [],
  label: [
    target?.name,
    target?.mentorName,
    target?.startDate && `starts ${toDisplayDate(target?.startDate)}`,
  ]
    .filter(Boolean)
    .join(" · "),
});
